var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7821 13.3259H18.1397V17.7375H7.7821V13.3259Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8764 9.78592H20.781C21.2283 9.79787 21.6535 9.98673 21.9673 10.3127C22.2812 10.6388 22.459 11.0765 22.4636 11.5339V15.9733C22.4636 16.4418 22.2815 16.8911 21.9575 17.2224C21.6335 17.5537 21.194 17.7398 20.7358 17.7398H18.1487V11.5339C18.1487 11.0654 18.3307 10.6161 18.6547 10.2848C18.9788 9.95354 19.4182 9.76743 19.8764 9.76743V9.78592Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19627 9.79337H6.10086C6.5481 9.80532 6.97336 9.99417 7.28717 10.3202C7.60098 10.6462 7.77887 11.084 7.7834 11.5414V17.738H5.19627C4.7396 17.738 4.30151 17.5531 3.97774 17.2239C3.65398 16.8946 3.4709 16.4476 3.46851 15.9807V11.5414C3.47327 11.0761 3.65741 10.6315 3.98091 10.3042C4.30441 9.97691 4.74116 9.79334 5.19627 9.79337Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05469 9.78982V7.1447C6.05708 6.44232 6.33166 5.76954 6.81828 5.27375C7.3049 4.77795 7.96388 4.49957 8.65086 4.49957H17.2807C17.9676 4.49957 18.6266 4.77795 19.1132 5.27375C19.5999 5.76954 19.8744 6.44232 19.8768 7.1447V9.78982",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05469 19.4996V17.7331",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8763 19.4996V17.7331",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51025 8.91473H11.238",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.694 8.91473H16.4217",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaging);
export default __webpack_public_path__ + "static/media/staging.2c1d684eba5ad5e4022a268d1221b826.svg";
export { ForwardRef as ReactComponent };